package navigation.home.proposal.selectservice

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.area.domain.repository.AreaRepository
import com.essntl.features.category.domain.repository.CategoryRepository
import com.essntl.features.profile.domain.use_case.GetCurrentUserUseCase
import com.essntl.features.proposal.ui.selectservice.SelectServiceEvent
import com.essntl.features.proposal.ui.selectservice.SelectServiceState
import com.essntl.features.proposal.ui.selectservice.SelectServiceViewModel
import com.essntl.features.service.domain.use_case.ExtraCategoryServiceUseCase
import com.essntl.features.supplier.domain.repository.SupplierRepository
import com.essntl.features.tag.domain.repository.TagRepository

class SelectServiceScreenModel(
    tagRepository: TagRepository,
    categoryRepository: CategoryRepository,
    supplierRepository: SupplierRepository,
    areaRepository: AreaRepository,
    extraCategoryServiceUseCase: ExtraCategoryServiceUseCase,
    getCurrentUserUseCase: GetCurrentUserUseCase,
    loadingManager: LoadingManager,
) : StateScreenModel<SelectServiceState>(SelectServiceState()) {
    private val selectServiceViewModel =
        SelectServiceViewModel(
            tagRepository = tagRepository,
            categoryRepository = categoryRepository,
            supplierRepository = supplierRepository,
            areaRepository = areaRepository,
            extraCategoryServiceUseCase = extraCategoryServiceUseCase,
            getCurrentUserUseCase = getCurrentUserUseCase,
            scope = screenModelScope,
            state = mutableState,
            loadingManager = loadingManager,
        )

    fun onEvent(event: SelectServiceEvent) {
        selectServiceViewModel.onEvent(event)
    }
}
